(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global.FormValidation = global.FormValidation || {}, global.FormValidation.locales = global.FormValidation.locales || {}, global.FormValidation.locales.da_DK = factory()));
})(this, (function () { 'use strict';

    /**
     * Danish language package
     * Translated by @Djarnis
     */

    var da_DK = {
        base64: {
            default: 'Udfyld venligst dette felt med en gyldig base64-kodet værdi',
        },
        between: {
            default: 'Udfyld venligst dette felt med en værdi mellem %s og %s',
            notInclusive: 'Indtast venligst kun en værdi mellem %s og %s',
        },
        bic: {
            default: 'Udfyld venligst dette felt med et gyldigt BIC-nummer',
        },
        callback: {
            default: 'Udfyld venligst dette felt med en gyldig værdi',
        },
        choice: {
            between: 'Vælg venligst %s - %s valgmuligheder',
            default: 'Udfyld venligst dette felt med en gyldig værdi',
            less: 'Vælg venligst mindst %s valgmuligheder',
            more: 'Vælg venligst højst %s valgmuligheder',
        },
        color: {
            default: 'Udfyld venligst dette felt med en gyldig farve',
        },
        creditCard: {
            default: 'Udfyld venligst dette felt med et gyldigt kreditkort-nummer',
        },
        cusip: {
            default: 'Udfyld venligst dette felt med et gyldigt CUSIP-nummer',
        },
        date: {
            default: 'Udfyld venligst dette felt med en gyldig dato',
            max: 'Angiv venligst en dato før %s',
            min: 'Angiv venligst en dato efter %s',
            range: 'Angiv venligst en dato mellem %s - %s',
        },
        different: {
            default: 'Udfyld venligst dette felt med en anden værdi',
        },
        digits: {
            default: 'Indtast venligst kun cifre',
        },
        ean: {
            default: 'Udfyld venligst dette felt med et gyldigt EAN-nummer',
        },
        ein: {
            default: 'Udfyld venligst dette felt med et gyldigt EIN-nummer',
        },
        emailAddress: {
            default: 'Udfyld venligst dette felt med en gyldig e-mail-adresse',
        },
        file: {
            default: 'Vælg venligst en gyldig fil',
        },
        greaterThan: {
            default: 'Udfyld venligst dette felt med en værdi større eller lig med %s',
            notInclusive: 'Udfyld venligst dette felt med en værdi større end %s',
        },
        grid: {
            default: 'Udfyld venligst dette felt med et gyldigt GRId-nummer',
        },
        hex: {
            default: 'Udfyld venligst dette felt med et gyldigt hexadecimal-nummer',
        },
        iban: {
            countries: {
                AD: 'Andorra',
                AE: 'De Forenede Arabiske Emirater',
                AL: 'Albanien',
                AO: 'Angola',
                AT: 'Østrig',
                AZ: 'Aserbajdsjan',
                BA: 'Bosnien-Hercegovina',
                BE: 'Belgien',
                BF: 'Burkina Faso',
                BG: 'Bulgarien',
                BH: 'Bahrain',
                BI: 'Burundi',
                BJ: 'Benin',
                BR: 'Brasilien',
                CH: 'Schweiz',
                CI: 'Elfenbenskysten',
                CM: 'Cameroun',
                CR: 'Costa Rica',
                CV: 'Kap Verde',
                CY: 'Cypern',
                CZ: 'Tjekkiet',
                DE: 'Tyskland',
                DK: 'Danmark',
                DO: 'Den Dominikanske Republik',
                DZ: 'Algeriet',
                EE: 'Estland',
                ES: 'Spanien',
                FI: 'Finland',
                FO: 'Færøerne',
                FR: 'Frankrig',
                GB: 'Storbritannien',
                GE: 'Georgien',
                GI: 'Gibraltar',
                GL: 'Grønland',
                GR: 'Grækenland',
                GT: 'Guatemala',
                HR: 'Kroatien',
                HU: 'Ungarn',
                IE: 'Irland',
                IL: 'Israel',
                IR: 'Iran',
                IS: 'Island',
                IT: 'Italien',
                JO: 'Jordan',
                KW: 'Kuwait',
                KZ: 'Kasakhstan',
                LB: 'Libanon',
                LI: 'Liechtenstein',
                LT: 'Litauen',
                LU: 'Luxembourg',
                LV: 'Letland',
                MC: 'Monaco',
                MD: 'Moldova',
                ME: 'Montenegro',
                MG: 'Madagaskar',
                MK: 'Makedonien',
                ML: 'Mali',
                MR: 'Mauretanien',
                MT: 'Malta',
                MU: 'Mauritius',
                MZ: 'Mozambique',
                NL: 'Holland',
                NO: 'Norge',
                PK: 'Pakistan',
                PL: 'Polen',
                PS: 'Palæstina',
                PT: 'Portugal',
                QA: 'Qatar',
                RO: 'Rumænien',
                RS: 'Serbien',
                SA: 'Saudi-Arabien',
                SE: 'Sverige',
                SI: 'Slovenien',
                SK: 'Slovakiet',
                SM: 'San Marino',
                SN: 'Senegal',
                TL: 'Østtimor',
                TN: 'Tunesien',
                TR: 'Tyrkiet',
                VG: 'Britiske Jomfruøer',
                XK: 'Kosovo',
            },
            country: 'Udfyld venligst dette felt med et gyldigt IBAN-nummer i %s',
            default: 'Udfyld venligst dette felt med et gyldigt IBAN-nummer',
        },
        id: {
            countries: {
                BA: 'Bosnien-Hercegovina',
                BG: 'Bulgarien',
                BR: 'Brasilien',
                CH: 'Schweiz',
                CL: 'Chile',
                CN: 'Kina',
                CZ: 'Tjekkiet',
                DK: 'Danmark',
                EE: 'Estland',
                ES: 'Spanien',
                FI: 'Finland',
                HR: 'Kroatien',
                IE: 'Irland',
                IS: 'Island',
                LT: 'Litauen',
                LV: 'Letland',
                ME: 'Montenegro',
                MK: 'Makedonien',
                NL: 'Holland',
                PL: 'Polen',
                RO: 'Rumænien',
                RS: 'Serbien',
                SE: 'Sverige',
                SI: 'Slovenien',
                SK: 'Slovakiet',
                SM: 'San Marino',
                TH: 'Thailand',
                TR: 'Tyrkiet',
                ZA: 'Sydafrika',
            },
            country: 'Udfyld venligst dette felt med et gyldigt identifikations-nummer i %s',
            default: 'Udfyld venligst dette felt med et gyldigt identifikations-nummer',
        },
        identical: {
            default: 'Udfyld venligst dette felt med den samme værdi',
        },
        imei: {
            default: 'Udfyld venligst dette felt med et gyldigt IMEI-nummer',
        },
        imo: {
            default: 'Udfyld venligst dette felt med et gyldigt IMO-nummer',
        },
        integer: {
            default: 'Udfyld venligst dette felt med et gyldigt tal',
        },
        ip: {
            default: 'Udfyld venligst dette felt med en gyldig IP adresse',
            ipv4: 'Udfyld venligst dette felt med en gyldig IPv4 adresse',
            ipv6: 'Udfyld venligst dette felt med en gyldig IPv6 adresse',
        },
        isbn: {
            default: 'Udfyld venligst dette felt med et gyldigt ISBN-nummer',
        },
        isin: {
            default: 'Udfyld venligst dette felt med et gyldigt ISIN-nummer',
        },
        ismn: {
            default: 'Udfyld venligst dette felt med et gyldigt ISMN-nummer',
        },
        issn: {
            default: 'Udfyld venligst dette felt med et gyldigt ISSN-nummer',
        },
        lessThan: {
            default: 'Udfyld venligst dette felt med en værdi mindre eller lig med %s',
            notInclusive: 'Udfyld venligst dette felt med en værdi mindre end %s',
        },
        mac: {
            default: 'Udfyld venligst dette felt med en gyldig MAC adresse',
        },
        meid: {
            default: 'Udfyld venligst dette felt med et gyldigt MEID-nummer',
        },
        notEmpty: {
            default: 'Udfyld venligst dette felt',
        },
        numeric: {
            default: 'Udfyld venligst dette felt med et gyldigt flydende decimaltal',
        },
        phone: {
            countries: {
                AE: 'De Forenede Arabiske Emirater',
                BG: 'Bulgarien',
                BR: 'Brasilien',
                CN: 'Kina',
                CZ: 'Tjekkiet',
                DE: 'Tyskland',
                DK: 'Danmark',
                ES: 'Spanien',
                FR: 'Frankrig',
                GB: 'Storbritannien',
                IN: 'Indien',
                MA: 'Marokko',
                NL: 'Holland',
                PK: 'Pakistan',
                RO: 'Rumænien',
                RU: 'Rusland',
                SK: 'Slovakiet',
                TH: 'Thailand',
                US: 'USA',
                VE: 'Venezuela',
            },
            country: 'Udfyld venligst dette felt med et gyldigt telefonnummer i %s',
            default: 'Udfyld venligst dette felt med et gyldigt telefonnummer',
        },
        promise: {
            default: 'Udfyld venligst dette felt med en gyldig værdi',
        },
        regexp: {
            default: 'Udfyld venligst dette felt med en værdi der matcher mønsteret',
        },
        remote: {
            default: 'Udfyld venligst dette felt med en gyldig værdi',
        },
        rtn: {
            default: 'Udfyld venligst dette felt med et gyldigt RTN-nummer',
        },
        sedol: {
            default: 'Udfyld venligst dette felt med et gyldigt SEDOL-nummer',
        },
        siren: {
            default: 'Udfyld venligst dette felt med et gyldigt SIREN-nummer',
        },
        siret: {
            default: 'Udfyld venligst dette felt med et gyldigt SIRET-nummer',
        },
        step: {
            default: 'Udfyld venligst dette felt med et gyldigt trin af %s',
        },
        stringCase: {
            default: 'Udfyld venligst kun dette felt med små bogstaver',
            upper: 'Udfyld venligst kun dette felt med store bogstaver',
        },
        stringLength: {
            between: 'Udfyld venligst dette felt med en værdi mellem %s og %s tegn',
            default: 'Udfyld venligst dette felt med en værdi af gyldig længde',
            less: 'Udfyld venligst dette felt med mindre end %s tegn',
            more: 'Udfyld venligst dette felt med mere end %s tegn',
        },
        uri: {
            default: 'Udfyld venligst dette felt med en gyldig URI',
        },
        uuid: {
            default: 'Udfyld venligst dette felt med et gyldigt UUID-nummer',
            version: 'Udfyld venligst dette felt med en gyldig UUID version %s-nummer',
        },
        vat: {
            countries: {
                AT: 'Østrig',
                BE: 'Belgien',
                BG: 'Bulgarien',
                BR: 'Brasilien',
                CH: 'Schweiz',
                CY: 'Cypern',
                CZ: 'Tjekkiet',
                DE: 'Tyskland',
                DK: 'Danmark',
                EE: 'Estland',
                EL: 'Grækenland',
                ES: 'Spanien',
                FI: 'Finland',
                FR: 'Frankrig',
                GB: 'Storbritannien',
                GR: 'Grækenland',
                HR: 'Kroatien',
                HU: 'Ungarn',
                IE: 'Irland',
                IS: 'Island',
                IT: 'Italien',
                LT: 'Litauen',
                LU: 'Luxembourg',
                LV: 'Letland',
                MT: 'Malta',
                NL: 'Holland',
                NO: 'Norge',
                PL: 'Polen',
                PT: 'Portugal',
                RO: 'Rumænien',
                RS: 'Serbien',
                RU: 'Rusland',
                SE: 'Sverige',
                SI: 'Slovenien',
                SK: 'Slovakiet',
                VE: 'Venezuela',
                ZA: 'Sydafrika',
            },
            country: 'Udfyld venligst dette felt med et gyldigt moms-nummer i %s',
            default: 'Udfyld venligst dette felt med et gyldig moms-nummer',
        },
        vin: {
            default: 'Udfyld venligst dette felt med et gyldigt VIN-nummer',
        },
        zipCode: {
            countries: {
                AT: 'Østrig',
                BG: 'Bulgarien',
                BR: 'Brasilien',
                CA: 'Canada',
                CH: 'Schweiz',
                CZ: 'Tjekkiet',
                DE: 'Tyskland',
                DK: 'Danmark',
                ES: 'Spanien',
                FR: 'Frankrig',
                GB: 'Storbritannien',
                IE: 'Irland',
                IN: 'Indien',
                IT: 'Italien',
                MA: 'Marokko',
                NL: 'Holland',
                PL: 'Polen',
                PT: 'Portugal',
                RO: 'Rumænien',
                RU: 'Rusland',
                SE: 'Sverige',
                SG: 'Singapore',
                SK: 'Slovakiet',
                US: 'USA',
            },
            country: 'Udfyld venligst dette felt med et gyldigt postnummer i %s',
            default: 'Udfyld venligst dette felt med et gyldigt postnummer',
        },
    };

    return da_DK;

}));
